import React from 'react';
import { useWindowSize } from 'usehooks-ts';
import TopBanner from '../components/TopBanner/TopBanner';
import Navbar from '../components/navbar/Navbar';
import Bottombar from '../components/sidebar/Bottombar';
import Sidebar from '../components/sidebar/Sidebar';
import MainApp from '../pages/MainApp/MainApp';
import './Layout.scss';
const Layout = () => {
  const { width } = useWindowSize();
  return (
    <>
      {width > 800 && <Navbar />}

      <div className='layout_wrapper'>
        <aside className='layout_wrapper_sidebar'>
          <Sidebar />
        </aside>
        <main className='layout_wrapper_app'>
          <div className='layout_wrapper_app_content'>
            <MainApp />
          </div>
        </main>
        {width < 800 && <Bottombar />}
      </div>
    </>
  );
};

export default Layout;
